import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

// Constants
import { routes } from '@sketch/constants'

// Components
import IndexLayout, { Title } from 'components/IndexLayout'
import { Link } from '@sketch/components'
import RecoveryCodeForm from 'modules/user/components/RecoveryCodeForm'

// Operations
import { useFetchInitialUser } from 'modules/user/operations/useFetchInitialUser'

// Styles
import {
  FormContainer,
  LinkDescription,
  Subtitle,
} from './RecoveryCodeView.styles'

interface LocationState {
  mfaToken: string
  from?: Location
}

const RecoveryCodeView: React.FC = () => {
  const history = useHistory()
  const location = useLocation<LocationState>()
  const fetchInitialUser = useFetchInitialUser()

  return (
    <IndexLayout
      headerLink="sign-up"
      variant="orange"
      maxContainerWidth="448px"
    >
      <Title>Enter Recovery Code</Title>
      <Subtitle>
        Can’t access your authenticator app? Enter a recovery code instead.
      </Subtitle>
      <FormContainer>
        <RecoveryCodeForm
          onCompleted={async () => {
            // Get the user profile for the first time now, since <UserContext /> (App.tsx)
            // can't do it because the user is not signed in until now
            await fetchInitialUser()

            history.push(location.state?.from || routes.ENTRY.create({}))
          }}
        />
      </FormContainer>
      <LinkDescription>
        Authenticator app working again?{' '}
        <Link
          to={{
            pathname: routes.VERIFICATION_CODE.create({}),
            state: {
              mfaToken: location.state.mfaToken,
              from: location.state.from,
            },
          }}
          variant="tertiary"
          isUnderlined
        >
          Enter verification code
        </Link>
      </LinkDescription>
      <LinkDescription>
        Lost your recovery codes?{' '}
        <Link
          external
          variant="tertiary"
          isUnderlined
          href="https://www.sketch.com/support/contact/"
        >
          Contact us
        </Link>
      </LinkDescription>
    </IndexLayout>
  )
}

export default RecoveryCodeView
